<h3>
    <a ng-click="editLicense(item.id)" ng-bind-html="item.company|cHighlight:highlight"></a>
</h3>
<div class="property-container">
    <ul class="workflow-property-list">
        <li>{{'admin.licensesView.created'|translate}}: {{ item.created | cDate }}</li>
        <li>{{'admin.licensesView.value'|translate}}: <span ng-if="item.unlimited">{{'admin.license.unlimited'|translate}}</span><span ng-if="!item.unlimited">{{ item.value }}</span></li>
        <li ng-if="item.authenticate"><a ng-click="login($event, item.id, item.authenticate.Url)">{{'logon'|translate}}</a></li>
    </ul>
</div>
